import { lazy, Suspense } from 'react'

import { Route, Switch } from 'react-router'

import { DevelopmentPage } from '@webapp/pages'

const SettingsDateFormatMigrationDraft = lazy(() =>
  import('./_migrations/settings-dateformat').then(
    ({ SettingsDateFormatMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsCurrencyMigrationDraft = lazy(() =>
  import('./_migrations/settings-currency').then(
    ({ SettingsCurrencyMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsCustomizeExpenseMigrationDraft = lazy(() =>
  import('./_migrations/settings-customizeexpense').then(
    ({ SettingsCustomizeExpenseMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsTaxMigrationDraft = lazy(() =>
  import('./_migrations/settings-tax').then(
    ({ SettingsTaxMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsAccessReportsMigrationDraft = lazy(() =>
  import('./_migrations/settings-access-reports').then(
    ({ SettingsAccessReportsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsCustomfieldsRfoMigrationDraft = lazy(() =>
  import('./_migrations/settings-customfields-rfo').then(
    ({ SettingsCustomfieldsRfoMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ApExpensesMigrationDraft = lazy(() =>
  import('./_migrations/ap-expenses').then(
    ({ ApExpensesMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ChartOfAccountsFlatMigrationDraft = lazy(() =>
  import('./_migrations/chartofaccounts-flat').then(
    ({ ChartOfAccountsFlatMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const BillApprovalsMigrationDraft = lazy(() =>
  import('./_migrations/bill-approvals').then(
    ({ BillApprovalsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsCustomfieldsPoMigrationDraft = lazy(() =>
  import('./_migrations/settings-customfields-po').then(
    ({ SettingsCustomfieldsPoMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ApprovedRequestsMigrationDraft = lazy(() =>
  import('./_migrations/approved-requests').then(
    ({ ApprovedRequestsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsApClosingMigrationDraft = lazy(() =>
  import('./_migrations/settings-ap-closing').then(
    ({ SettingsApClosingMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const PaymentReceivingReportMigrationDraft = lazy(() =>
  import('./_migrations/payment-receivingreport').then(
    ({ PaymentReceivingReportMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ApReconcileMigrationDraft = lazy(() =>
  import('./_migrations/ap-reconcile').then(
    ({ ApReconcileMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const PaymentExpenseRecordsMigrationDraft = lazy(() =>
  import('./_migrations/payment-expenserecords').then(
    ({ PaymentExpenseRecordsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ReportsMigrationDraft = lazy(() =>
  import('./_migrations/reports').then(({ ReportsMigrationDraft: Draft }) => ({
    default: Draft,
  }))
)

const ApUnbilledItemsMigrationDraft = lazy(() =>
  import('./_migrations/ap-unbilled-items').then(
    ({ ApUnbilledItemsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const ApSpendTrackerMigrationDraft = lazy(() =>
  import('./_migrations/ap-spend-tracker').then(
    ({ ApSpendTrackerMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsFinancialsMigrationDraft = lazy(() =>
  import('./_migrations/settings-financials').then(
    ({ SettingsFinancialsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const SettingsExportcsvMigrationDraft = lazy(() =>
  import('./_migrations/settings-exportcsv').then(
    ({ SettingsExportcsvMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const TravelsMigrationDraft = lazy(() =>
  import('./_migrations/travels').then(({ TravelsMigrationDraft: Draft }) => ({
    default: Draft,
  }))
)

const AdminToolsMigrationDraft = lazy(() =>
  import('./_migrations/admin-tools').then(
    ({ AdminToolsMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const DashboardMigrationDraft = lazy(() =>
  import('./_migrations/dashboard').then(
    ({ DashboardMigrationDraft: Draft }) => ({ default: Draft })
  )
)

const IntegrationQuickbooksMigrationDraft = lazy(() =>
  import('./_migrations/integration-quickbooks').then(
    ({ IntegrationQuickbooksMigrationDraft: Draft }) => ({ default: Draft })
  )
)

export const _DevRouter = () => {
  return (
    <Switch>
      <Route path='/dev/migrations/settings-dateformat'>
        <Suspense fallback={null}>
          <SettingsDateFormatMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-currency'>
        <Suspense fallback={null}>
          <SettingsCurrencyMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-customizeexpense'>
        <Suspense fallback={null}>
          <SettingsCustomizeExpenseMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-tax'>
        <Suspense fallback={null}>
          <SettingsTaxMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-access-reports'>
        <Suspense fallback={null}>
          <SettingsAccessReportsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-customfields-rfo'>
        <Suspense fallback={null}>
          <SettingsCustomfieldsRfoMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/ap-expenses'>
        <Suspense fallback={null}>
          <ApExpensesMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/chartofaccounts-flat'>
        <Suspense fallback={null}>
          <ChartOfAccountsFlatMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/bill-approvals'>
        <Suspense fallback={null}>
          <BillApprovalsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-customfields-po'>
        <Suspense fallback={null}>
          <SettingsCustomfieldsPoMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/approved-requests'>
        <Suspense fallback={null}>
          <ApprovedRequestsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-ap-closing'>
        <Suspense fallback={null}>
          <SettingsApClosingMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/payment-receivingreport'>
        <Suspense fallback={null}>
          <PaymentReceivingReportMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/ap-reconcile'>
        <Suspense fallback={null}>
          <ApReconcileMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/payment-expenserecords'>
        <Suspense fallback={null}>
          <PaymentExpenseRecordsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/reports'>
        <Suspense fallback={null}>
          <ReportsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/ap-unbilled-items'>
        <Suspense fallback={null}>
          <ApUnbilledItemsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/ap-spend-tracker'>
        <Suspense fallback={null}>
          <ApSpendTrackerMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-financials'>
        <Suspense fallback={null}>
          <SettingsFinancialsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/settings-exportcsv'>
        <Suspense fallback={null}>
          <SettingsExportcsvMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/travels'>
        <Suspense fallback={null}>
          <TravelsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/admin-tools'>
        <Suspense fallback={null}>
          <AdminToolsMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/dashboard'>
        <Suspense fallback={null}>
          <DashboardMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev/migrations/integration-quickbooks'>
        <Suspense fallback={null}>
          <IntegrationQuickbooksMigrationDraft />
        </Suspense>
      </Route>
      <Route path='/dev' component={DevelopmentPage} />
    </Switch>
  )
}
_DevRouter.displayName = '_DevRouter'
